import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { CUSTOM_FIELDS_EXPRESSION_SCHEMA_ACTION_TYPE } from 'store/system/types/customFieldsExpressionSchema.types';

const initialState = null;

// Cached schema has 8 per-target ExpressionDefinitionDto entries; the same 8 virtual
// CustomFields entities (LoanCustomFields, BorrowerCustomFields, ...) are
// merged into every per-target context. Patching must touch all 8 to stay in sync.
const SCHEMA_KEYS = [
  'loanCustomFieldsSchema',
  'assetCustomFieldsSchema',
  'borrowerCustomFieldsSchema',
  'incomeCustomFieldsSchema',
  'liabilityCustomFieldsSchema',
  'propertyCustomFieldsSchema',
  'subjectPropertyCustomFieldsSchema',
  'nbeCustomFieldsSchema',
];

const customFieldsEntityName = target => `${target}CustomFields`;

const customFieldsExpressionSchemaReducer = produce((draft, { type, payload }) => {
  switch (type) {
    case CUSTOM_FIELDS_EXPRESSION_SCHEMA_ACTION_TYPE.GET_SCHEMA:
      return payload ?? initialState;

    case CUSTOM_FIELDS_EXPRESSION_SCHEMA_ACTION_TYPE.PATCH_SCHEMA: {
      if (!draft) {
        return draft;
      }

      const { target, removeKey, addKey, valueType } = payload ?? {};

      if (!target || (!removeKey && !addKey)) {
        return draft;
      }

      const entityName = customFieldsEntityName(target);

      SCHEMA_KEYS.forEach(schemaKey => {
        const entity = draft[schemaKey]?.entities?.[entityName];

        if (!entity) {
          return;
        }

        if (removeKey && entity[removeKey] !== undefined) {
          delete entity[removeKey];
        }

        if (addKey) {
          entity[addKey] = valueType;
        }
      });

      return draft;
    }

    case RESET_STATE:
      return initialState;

    default:
      return draft;
  }
}, initialState);

export default customFieldsExpressionSchemaReducer;
